<template>
  <m-dialog ref="previewNameDlg" :btnsave="false" title="Cetak KTA Berdasarkan Nama">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="10" md="12" lg="10" xl="7">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <p class="title black--text mb-2">Cari berdasarkan Nama atau NIK</p>
                <p class="caption">Ketik Nama atau NIK kemudian tekan enter dan centang Anggota terpilih</p>
                <v-form @submit.prevent data-vv-scope="form" lazy-validation>
                  <v-autocomplete
                    multiple
                    dense
                    outlined
                    height="50"
                    placeholder="Pilih Anggota"
                    :items="itemKandidats"
                    :search-input.sync="search"
                    v-model="selected"
                    item-value="id"
                    item-text="nama"
                    return-object
                    label="Anggota"
                    @keyup.enter="getKandidat(search)"
                  >
                    <template v-slot:selection="data">
                      <v-chip small color="primary" v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="remove(data.item)">
                        <v-avatar left>
                          <v-icon>mdi-account</v-icon>
                        </v-avatar>
                        {{ data.item.nama }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-form>
              </v-col>
              <v-col cols="12" v-if="selected.length > 0">
                <p class="title black--text mb-2">KTA Anggota terpilih</p>
                <v-chip class="mx-2" color="info" v-for="item in selected" :key="item.index">{{ item.nama }}</v-chip>
              </v-col>
              <v-col>
                <p v-if="items.length > 0" class="title black--text mb-2">Preview KTA</p>
                <v-row v-for="preview in items" :key="preview.index">
                  <v-col cols="12" sm="12" md="6" lg="6" align-end colbox>
                    <img height="250" class="pa-2" :src="preview.url_kta_depan ? preview.url_kta_depan : 'img/no-image.jpeg'" alt="avatar" />
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" align-end colbox>
                    <img height="250" class="pa-2" :src="preview.url_kta_belakang ? preview.url_kta_belakang : 'img/no-image.jpeg'" alt="avatar" />
                  </v-col> </v-row
              ></v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :small="$vuetify.breakpoint.smAndDown" depressed color="error" @click="previewKTA()"> <v-icon>mdi-file-pdf-box</v-icon>PREVIEW KTA</v-btn>
            <v-btn :small="$vuetify.breakpoint.smAndDown" depressed color="success" @click="cetakKTA()"> <v-icon>mdi-file-pdf-box</v-icon>CETAK KTA</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <PreviewCustomNameDlg ref="previewCustomNameDlg" />
  </m-dialog>
</template>

<script>
// const lc = window.localStorage;
// const TOKEN = "siapbbjatimtoken";
// Basic Use - Covers most scenarios
import { VueEditor } from "vue2-editor";
import PreviewCustomNameDlg from "../../warga/components/PreviewKTAKTPByName.vue";
// import { API } from "@/const";
// const M_API = API + "/api";
export default {
  components: {
    VueEditor,
    PreviewCustomNameDlg
  },
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      items: [],
      itemKandidats: [],
      selected: [],
      search: null,
      kotaid: null
    };
  },
  methods: {
    // eslint-disable-next-line
    open(kotaid) {
      this.items = [];
      this.kotaid = kotaid;
      let x = this.$refs.previewNameDlg.open();
      this.$validator.reset();
      this.selected = [];
      this.isReset = true;
      this.$nextTick(() => {
        this.isReset = false;
      });
      return x;
    },
    getKandidat(val) {
      return this.$store
        .dispatch("warga/getKandidatKTA", { s: val, kotaid: this.kotaid })
        .then(res => {
          this.itemKandidats = res;
        })
        .catch(e => e);
    },

    previewKTA() {
      this.$store
        .dispatch("warga/previewByNama", { obj: this.selected, kota_id: this.kotaid })
        .then(res => {
          this.items = res;
        })
        .catch(e => e);
    },
    previewCustom(items, kotaid) {
      this.$refs.previewCustomNameDlg.open(items, kotaid).then(() => {
        this.load();
      });
    },
    cetakKTA() {
      this.$store
        .dispatch("warga/cetakCustomByNama", { obj: this.selected, kota_id: this.kotaid })
        .then(() => {})
        .catch(e => e);
    }
  }
};
</script>
